import React from 'react';
import AntCol from 'antd-core/es/col';

const Col = React.forwardRef((props, ref) => {
    return React.createElement(AntCol, Object.assign({ "data-testid": 'tend-ui-col' }, props, { ref: ref }));
});
Col.displayName = 'Col';

export { Col };
//# sourceMappingURL=Col.js.map
